import { Image as ImageIcon } from 'lucide-react';

const Gallery = () => {
  const galleryImages = [
    {
      title: "KAROBAR Team - Baazigar Event",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/l4i7elt4_WhatsApp%20Image%202026-06-04%20at%209.29.02%20PM.jpeg",
      category: "Team"
    },
    {
      title: "KAROBAR Team at Campus Pathway",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/8x9d31fd_IMG_9625.HEIC",
      category: "Team"
    },
    {
      title: "KAROBAR Team Group Photo",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/3aoswqyc_IMG_9353.HEIC",
      category: "Team"
    },
  ];

  return (
    <div className="pt-20" data-testid="gallery-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">MOMENTS CAPTURED</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>GALLERY</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">Explore the vibrant moments from KAROBAR events, workshops, and community gatherings.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((item, index) => (
              <div key={index} className="glass-card overflow-hidden group" data-testid={`gallery-item-${index}`}>
                <div className="relative h-64 overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                    <div>
                      <p className="text-gold-500 text-xs font-bold tracking-widest uppercase mb-1">{item.category}</p>
                      <h3 className="text-white font-black text-lg" style={{ fontFamily: 'Open Sans' }}>{item.title}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center glass-card p-12">
            <ImageIcon className="w-16 h-16 text-gold-500 mx-auto mb-6" />
            <h2 className="text-3xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>SHARE YOUR MOMENTS</h2>
            <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">Have photos from KAROBAR events? We'd love to feature them in our gallery!</p>
            <a href="mailto:karobar.dps@christuniversity.in" className="btn-primary inline-block" data-testid="submit-photos-button">
              SUBMIT YOUR PHOTOS
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;